import { FIELD_TYPES } from "./types"

export const products = [
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Nike Air Force 1 NDESTRUKT",
        "code": "38BEE270",
        "sku": "WW75K5210YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 16.19,
        "priceSale": 16.19,
        "totalRating": 2.5,
        "totalReview": 4544,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 4257,
                "reviewCount": 2481
            },
            {
                "name": "2 Star",
                "starCount": 8136,
                "reviewCount": 831
            },
            {
                "name": "3 Star",
                "starCount": 9246,
                "reviewCount": 4612
            },
            {
                "name": "4 Star",
                "starCount": 553,
                "reviewCount": 5948
            },
            {
                "name": "5 Star",
                "starCount": 3732,
                "reviewCount": 4522
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 6778,
                "postedAt": "2023-04-21T05:58:02.231Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 233,
                "postedAt": "2023-04-20T04:58:02.231Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 5600,
                "postedAt": "2023-04-19T03:58:02.231Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 1517,
                "postedAt": "2023-04-18T02:58:02.231Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 2972,
                "postedAt": "2023-04-17T01:58:02.231Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 9841,
                "postedAt": "2023-04-16T00:58:02.231Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 9848,
                "postedAt": "2023-04-14T23:58:02.231Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 7466,
                "postedAt": "2023-04-13T22:58:02.231Z"
            }
        ],
        "status": "sale",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 33,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 908,
        "createdAt": "2023-04-21T05:58:02.231Z",
        "category": "Apparel",
        "gender": "Men",
        "colors": [
            "#00AB55",
            "#000000"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Foundations Matte Flip Flop",
        "code": "38BEE271",
        "sku": "WW75K5211YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 35.71,
        "priceSale": null,
        "totalRating": 2,
        "totalReview": 340,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 7589,
                "reviewCount": 5719
            },
            {
                "name": "2 Star",
                "starCount": 3196,
                "reviewCount": 7335
            },
            {
                "name": "3 Star",
                "starCount": 3870,
                "reviewCount": 5898
            },
            {
                "name": "4 Star",
                "starCount": 8870,
                "reviewCount": 620
            },
            {
                "name": "5 Star",
                "starCount": 7969,
                "reviewCount": 7660
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 7497,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 8593,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 5561,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 7686,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 798,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 8611,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 8923,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 4464,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 364,
        "createdAt": "2023-04-20T04:58:02.232Z",
        "category": "Shose",
        "gender": "Men",
        "colors": [
            "#000000",
            "#FFFFFF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Nike Air Zoom Pegasus 37 A.I.R. Chaz Bear",
        "code": "38BEE272",
        "sku": "WW75K5212YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 34.3,
        "priceSale": null,
        "totalRating": 4.9,
        "totalReview": 8052,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 7542,
                "reviewCount": 2296
            },
            {
                "name": "2 Star",
                "starCount": 5624,
                "reviewCount": 3393
            },
            {
                "name": "3 Star",
                "starCount": 9180,
                "reviewCount": 2613
            },
            {
                "name": "4 Star",
                "starCount": 1238,
                "reviewCount": 6703
            },
            {
                "name": "5 Star",
                "starCount": 1882,
                "reviewCount": 626
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 1110,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 7624,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 1258,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 9015,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 4167,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 4894,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 8649,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 8678,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "new",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 158,
        "createdAt": "2023-04-19T03:58:02.232Z",
        "category": "Accessories",
        "gender": "Men",
        "colors": [
            "#FFFFFF",
            "#FFC0CB"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Arizona Soft Footbed Sandal",
        "code": "38BEE273",
        "sku": "WW75K5213YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 93.1,
        "priceSale": 93.1,
        "totalRating": 2,
        "totalReview": 538,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 4474,
                "reviewCount": 7740
            },
            {
                "name": "2 Star",
                "starCount": 8722,
                "reviewCount": 9349
            },
            {
                "name": "3 Star",
                "starCount": 1808,
                "reviewCount": 4837
            },
            {
                "name": "4 Star",
                "starCount": 4067,
                "reviewCount": 6534
            },
            {
                "name": "5 Star",
                "starCount": 5371,
                "reviewCount": 5276
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 3203,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 1351,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 9530,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 2282,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 1898,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 7562,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 5204,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 768,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "sale",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 50,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 564,
        "createdAt": "2023-04-18T02:58:02.232Z",
        "category": "Accessories",
        "gender": "Kids",
        "colors": [
            "#FFC0CB",
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Boston Soft Footbed Sandal",
        "code": "38BEE274",
        "sku": "WW75K5214YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 55.47,
        "priceSale": null,
        "totalRating": 4,
        "totalReview": 3617,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 6807,
                "reviewCount": 2780
            },
            {
                "name": "2 Star",
                "starCount": 5197,
                "reviewCount": 7162
            },
            {
                "name": "3 Star",
                "starCount": 8945,
                "reviewCount": 5801
            },
            {
                "name": "4 Star",
                "starCount": 7266,
                "reviewCount": 8260
            },
            {
                "name": "5 Star",
                "starCount": 6327,
                "reviewCount": 6797
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 7972,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 7527,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 6416,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 7046,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 4947,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 5042,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 8075,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 2621,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "out_of_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 885,
        "createdAt": "2023-04-17T01:58:02.232Z",
        "category": "Shose",
        "gender": "Men",
        "colors": [
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Zoom Freak 2",
        "code": "38BEE275",
        "sku": "WW75K5215YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 89.09,
        "priceSale": null,
        "totalRating": 5,
        "totalReview": 8257,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 4881,
                "reviewCount": 131
            },
            {
                "name": "2 Star",
                "starCount": 7177,
                "reviewCount": 1123
            },
            {
                "name": "3 Star",
                "starCount": 383,
                "reviewCount": 8739
            },
            {
                "name": "4 Star",
                "starCount": 6106,
                "reviewCount": 7902
            },
            {
                "name": "5 Star",
                "starCount": 7664,
                "reviewCount": 4441
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 5595,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 9452,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 641,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 8641,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 6935,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 1138,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 2409,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 56,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 27,
        "createdAt": "2023-04-16T00:58:02.232Z",
        "category": "Shose",
        "gender": "Kids",
        "colors": [
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Gazelle Vintage low-top sneakers",
        "code": "38BEE276",
        "sku": "WW75K5216YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 44.39,
        "priceSale": 44.39,
        "totalRating": 4.9,
        "totalReview": 5674,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 3879,
                "reviewCount": 5004
            },
            {
                "name": "2 Star",
                "starCount": 9028,
                "reviewCount": 1312
            },
            {
                "name": "3 Star",
                "starCount": 4968,
                "reviewCount": 3436
            },
            {
                "name": "4 Star",
                "starCount": 6838,
                "reviewCount": 8082
            },
            {
                "name": "5 Star",
                "starCount": 5040,
                "reviewCount": 2877
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 8938,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 5356,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 7563,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 4713,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 8274,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 3633,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 4923,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 9764,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "sale",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 86,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 187,
        "createdAt": "2023-04-14T23:58:02.232Z",
        "category": "Shose",
        "gender": "Women",
        "colors": [
            "#00AB55",
            "#000000"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Jordan Delta",
        "code": "38BEE277",
        "sku": "WW75K5217YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 26.92,
        "priceSale": null,
        "totalRating": 5,
        "totalReview": 1,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 8257,
                "reviewCount": 2807
            },
            {
                "name": "2 Star",
                "starCount": 9351,
                "reviewCount": 3991
            },
            {
                "name": "3 Star",
                "starCount": 788,
                "reviewCount": 1626
            },
            {
                "name": "4 Star",
                "starCount": 3763,
                "reviewCount": 6208
            },
            {
                "name": "5 Star",
                "starCount": 2027,
                "reviewCount": 7944
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 4806,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 2262,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 8802,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 9554,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 8999,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 5030,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 8572,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 8496,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 912,
        "createdAt": "2023-04-13T22:58:02.232Z",
        "category": "Apparel",
        "gender": "Women",
        "colors": [
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_9.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Air Jordan XXXV PF",
        "code": "38BEE278",
        "sku": "WW75K5218YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 45.35,
        "priceSale": null,
        "totalRating": 3.7,
        "totalReview": 9188,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 5267,
                "reviewCount": 3592
            },
            {
                "name": "2 Star",
                "starCount": 1022,
                "reviewCount": 681
            },
            {
                "name": "3 Star",
                "starCount": 6838,
                "reviewCount": 3019
            },
            {
                "name": "4 Star",
                "starCount": 8716,
                "reviewCount": 7016
            },
            {
                "name": "5 Star",
                "starCount": 9160,
                "reviewCount": 4028
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 7509,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 5987,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 7034,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 9959,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 3289,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 5734,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 3532,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 881,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 502,
        "createdAt": "2023-04-12T21:58:02.232Z",
        "category": "Shose",
        "gender": "Men",
        "colors": [
            "#FFFFFF",
            "#FFC0CB"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_10.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Rod Laver low-top sneakers",
        "code": "38BEE279",
        "sku": "WW75K5219YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 26.96,
        "priceSale": 26.96,
        "totalRating": 2.5,
        "totalReview": 2473,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 9281,
                "reviewCount": 1317
            },
            {
                "name": "2 Star",
                "starCount": 3846,
                "reviewCount": 7699
            },
            {
                "name": "3 Star",
                "starCount": 6674,
                "reviewCount": 2971
            },
            {
                "name": "4 Star",
                "starCount": 5507,
                "reviewCount": 4518
            },
            {
                "name": "5 Star",
                "starCount": 186,
                "reviewCount": 1927
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 8657,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 190,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 5780,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 6518,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 4521,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 841,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 7326,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 9943,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "sale",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 93,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 308,
        "createdAt": "2023-04-11T20:58:02.232Z",
        "category": "Accessories",
        "gender": "Women",
        "colors": [
            "#FFFFFF",
            "#FFC0CB",
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b11",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_11.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Kyrie 7 EP Sisterhood",
        "code": "38BEE2710",
        "sku": "WW75K52110YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 78.22,
        "priceSale": null,
        "totalRating": 2,
        "totalReview": 6979,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 394,
                "reviewCount": 4179
            },
            {
                "name": "2 Star",
                "starCount": 982,
                "reviewCount": 2632
            },
            {
                "name": "3 Star",
                "starCount": 4142,
                "reviewCount": 2074
            },
            {
                "name": "4 Star",
                "starCount": 3938,
                "reviewCount": 382
            },
            {
                "name": "5 Star",
                "starCount": 8919,
                "reviewCount": 9938
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 3638,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 9363,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 9610,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 6343,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 1341,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 8034,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 8913,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 5247,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 844,
        "createdAt": "2023-04-10T19:58:02.232Z",
        "category": "Shose",
        "gender": "Women",
        "colors": [
            "#FFC0CB",
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b12",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_12.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Pharrell Williams Human Race NMD sneakers",
        "code": "38BEE2711",
        "sku": "WW75K52111YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 35.54,
        "priceSale": null,
        "totalRating": 4.9,
        "totalReview": 4820,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 6971,
                "reviewCount": 2851
            },
            {
                "name": "2 Star",
                "starCount": 2289,
                "reviewCount": 1120
            },
            {
                "name": "3 Star",
                "starCount": 9819,
                "reviewCount": 4143
            },
            {
                "name": "4 Star",
                "starCount": 3223,
                "reviewCount": 120
            },
            {
                "name": "5 Star",
                "starCount": 559,
                "reviewCount": 2905
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 9408,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 4973,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 9769,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 1583,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 1506,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 7614,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 6289,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 9082,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 348,
        "createdAt": "2023-04-09T18:58:02.232Z",
        "category": "Shose",
        "gender": "Men",
        "colors": [
            "#FFFFFF",
            "#FFC0CB",
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b13",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_13.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Nike Blazer Low 77 Vintage",
        "code": "38BEE2712",
        "sku": "WW75K52112YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 90.69,
        "priceSale": 90.69,
        "totalRating": 4.8,
        "totalReview": 5416,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 273,
                "reviewCount": 7031
            },
            {
                "name": "2 Star",
                "starCount": 6681,
                "reviewCount": 5752
            },
            {
                "name": "3 Star",
                "starCount": 6446,
                "reviewCount": 1502
            },
            {
                "name": "4 Star",
                "starCount": 4299,
                "reviewCount": 495
            },
            {
                "name": "5 Star",
                "starCount": 2772,
                "reviewCount": 6346
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 7983,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 5430,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 7770,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 5814,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 2976,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 7314,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 2775,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 509,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "sale",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 74,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 358,
        "createdAt": "2023-04-08T17:58:02.232Z",
        "category": "Accessories",
        "gender": "Women",
        "colors": [
            "#FFFFFF",
            "#FFC0CB",
            "#FF4842",
            "#1890FF",
            "#94D82D"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b14",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_14.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "ASMC Winter Boot Cold.Rdy",
        "code": "38BEE2713",
        "sku": "WW75K52113YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 63.61,
        "priceSale": null,
        "totalRating": 4,
        "totalReview": 2215,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 8907,
                "reviewCount": 8036
            },
            {
                "name": "2 Star",
                "starCount": 3624,
                "reviewCount": 4910
            },
            {
                "name": "3 Star",
                "starCount": 8778,
                "reviewCount": 4841
            },
            {
                "name": "4 Star",
                "starCount": 8045,
                "reviewCount": 9381
            },
            {
                "name": "5 Star",
                "starCount": 9764,
                "reviewCount": 7945
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 9417,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 2796,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 1708,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 4900,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 7275,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 6949,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 4350,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 8447,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 68,
        "createdAt": "2023-04-07T16:58:02.232Z",
        "category": "Accessories",
        "gender": "Women",
        "colors": [
            "#FF4842",
            "#1890FF",
            "#94D82D"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b15",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_15.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "ZX 8000 Lego sneakers",
        "code": "38BEE2714",
        "sku": "WW75K52114YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 67.55,
        "priceSale": null,
        "totalRating": 2,
        "totalReview": 9340,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 8054,
                "reviewCount": 6241
            },
            {
                "name": "2 Star",
                "starCount": 443,
                "reviewCount": 1972
            },
            {
                "name": "3 Star",
                "starCount": 9247,
                "reviewCount": 191
            },
            {
                "name": "4 Star",
                "starCount": 8622,
                "reviewCount": 5928
            },
            {
                "name": "5 Star",
                "starCount": 5198,
                "reviewCount": 6338
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 9879,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 8283,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 967,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 3427,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 3790,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 921,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 2569,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 8207,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "new",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 801,
        "createdAt": "2023-04-06T15:58:02.232Z",
        "category": "Shose",
        "gender": "Kids",
        "colors": [
            "#00AB55",
            "#000000"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b16",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_16.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Ultraboost 21 sneakers",
        "code": "38BEE2715",
        "sku": "WW75K52115YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 94.75,
        "priceSale": 94.75,
        "totalRating": 3.7,
        "totalReview": 5917,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 2061,
                "reviewCount": 7199
            },
            {
                "name": "2 Star",
                "starCount": 9029,
                "reviewCount": 1035
            },
            {
                "name": "3 Star",
                "starCount": 8907,
                "reviewCount": 3376
            },
            {
                "name": "4 Star",
                "starCount": 1793,
                "reviewCount": 4290
            },
            {
                "name": "5 Star",
                "starCount": 5405,
                "reviewCount": 2215
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 276,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 8880,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 5871,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 806,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 2124,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 1680,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 1481,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 1158,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "sale",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 32,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 826,
        "createdAt": "2023-04-05T14:58:02.232Z",
        "category": "Accessories",
        "gender": "Kids",
        "colors": [
            "#1890FF",
            "#94D82D",
            "#FFC107"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b17",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_17.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "2750 Cotu Classic Sneaker",
        "code": "38BEE2716",
        "sku": "WW75K52116YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 75.78,
        "priceSale": null,
        "totalRating": 1.4,
        "totalReview": 1088,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 7511,
                "reviewCount": 8109
            },
            {
                "name": "2 Star",
                "starCount": 8083,
                "reviewCount": 1413
            },
            {
                "name": "3 Star",
                "starCount": 6017,
                "reviewCount": 9012
            },
            {
                "name": "4 Star",
                "starCount": 6374,
                "reviewCount": 5450
            },
            {
                "name": "5 Star",
                "starCount": 3507,
                "reviewCount": 8837
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 7448,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 5594,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 348,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 9827,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 5351,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 3688,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 6215,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 8262,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "out_of_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 412,
        "createdAt": "2023-04-04T13:58:02.232Z",
        "category": "Shose",
        "gender": "Kids",
        "colors": [
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b18",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_18.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "ZX 9000 A-ZX Series sneakers",
        "code": "38BEE2717",
        "sku": "WW75K52117YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 39.6,
        "priceSale": null,
        "totalRating": 2.4,
        "totalReview": 3840,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 9881,
                "reviewCount": 7666
            },
            {
                "name": "2 Star",
                "starCount": 3924,
                "reviewCount": 447
            },
            {
                "name": "3 Star",
                "starCount": 534,
                "reviewCount": 8275
            },
            {
                "name": "4 Star",
                "starCount": 2222,
                "reviewCount": 8533
            },
            {
                "name": "5 Star",
                "starCount": 7774,
                "reviewCount": 9612
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 8435,
                "postedAt": "2023-04-21T05:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 8741,
                "postedAt": "2023-04-20T04:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 5873,
                "postedAt": "2023-04-19T03:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 2917,
                "postedAt": "2023-04-18T02:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 4346,
                "postedAt": "2023-04-17T01:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 8850,
                "postedAt": "2023-04-16T00:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 9761,
                "postedAt": "2023-04-14T23:58:02.232Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 2287,
                "postedAt": "2023-04-13T22:58:02.232Z"
            }
        ],
        "status": "",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 448,
        "createdAt": "2023-04-03T12:58:02.232Z",
        "category": "Accessories",
        "gender": "Women",
        "colors": [
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b19",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_19.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Madrid Big Buckle Sandal",
        "code": "38BEE2718",
        "sku": "WW75K52118YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 52.84,
        "priceSale": 52.84,
        "totalRating": 1.8,
        "totalReview": 9717,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 2418,
                "reviewCount": 7811
            },
            {
                "name": "2 Star",
                "starCount": 252,
                "reviewCount": 7435
            },
            {
                "name": "3 Star",
                "starCount": 6506,
                "reviewCount": 5648
            },
            {
                "name": "4 Star",
                "starCount": 7452,
                "reviewCount": 8819
            },
            {
                "name": "5 Star",
                "starCount": 2704,
                "reviewCount": 6371
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 1631,
                "postedAt": "2023-04-21T05:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 8349,
                "postedAt": "2023-04-20T04:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 2680,
                "postedAt": "2023-04-19T03:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 7732,
                "postedAt": "2023-04-18T02:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 4697,
                "postedAt": "2023-04-17T01:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 3622,
                "postedAt": "2023-04-16T00:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 7987,
                "postedAt": "2023-04-14T23:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 7981,
                "postedAt": "2023-04-13T22:58:02.233Z"
            }
        ],
        "status": "sale",
        "inventoryType": "out_of_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 45,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 360,
        "createdAt": "2023-04-02T11:58:02.233Z",
        "category": "Apparel",
        "gender": "Women",
        "colors": [
            "#00AB55",
            "#000000"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b20",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_20.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Chuck 70 Hi Sneaker",
        "code": "38BEE2719",
        "sku": "WW75K52119YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 72.8,
        "priceSale": null,
        "totalRating": 5,
        "totalReview": 1870,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 5212,
                "reviewCount": 81
            },
            {
                "name": "2 Star",
                "starCount": 4956,
                "reviewCount": 9641
            },
            {
                "name": "3 Star",
                "starCount": 5353,
                "reviewCount": 8744
            },
            {
                "name": "4 Star",
                "starCount": 5295,
                "reviewCount": 6114
            },
            {
                "name": "5 Star",
                "starCount": 9762,
                "reviewCount": 33
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 5197,
                "postedAt": "2023-04-21T05:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 4413,
                "postedAt": "2023-04-20T04:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 217,
                "postedAt": "2023-04-19T03:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 4474,
                "postedAt": "2023-04-18T02:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 9947,
                "postedAt": "2023-04-17T01:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 48,
                "postedAt": "2023-04-16T00:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 9355,
                "postedAt": "2023-04-14T23:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 3374,
                "postedAt": "2023-04-13T22:58:02.233Z"
            }
        ],
        "status": "new",
        "inventoryType": "in_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 762,
        "createdAt": "2023-04-01T10:58:02.233Z",
        "category": "Apparel",
        "gender": "Kids",
        "colors": [
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b21",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_21.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Relaxed Adjustable Strap Slingback Sandal",
        "code": "38BEE2720",
        "sku": "WW75K52120YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 83.08,
        "priceSale": null,
        "totalRating": 2.9,
        "totalReview": 2316,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 7762,
                "reviewCount": 6638
            },
            {
                "name": "2 Star",
                "starCount": 4590,
                "reviewCount": 5918
            },
            {
                "name": "3 Star",
                "starCount": 9461,
                "reviewCount": 9143
            },
            {
                "name": "4 Star",
                "starCount": 1712,
                "reviewCount": 2556
            },
            {
                "name": "5 Star",
                "starCount": 8094,
                "reviewCount": 3636
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 4011,
                "postedAt": "2023-04-21T05:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 2819,
                "postedAt": "2023-04-20T04:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 6333,
                "postedAt": "2023-04-19T03:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 7994,
                "postedAt": "2023-04-18T02:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 8285,
                "postedAt": "2023-04-17T01:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 3917,
                "postedAt": "2023-04-16T00:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 8341,
                "postedAt": "2023-04-14T23:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 3924,
                "postedAt": "2023-04-13T22:58:02.233Z"
            }
        ],
        "status": "",
        "inventoryType": "out_of_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 437,
        "createdAt": "2023-03-31T09:58:02.233Z",
        "category": "Accessories",
        "gender": "Men",
        "colors": [
            "#FF4842",
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b22",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_22.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Superturf Adventure X Atmos",
        "code": "38BEE2721",
        "sku": "WW75K52121YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 85.02,
        "priceSale": 85.02,
        "totalRating": 3.9,
        "totalReview": 301,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 8726,
                "reviewCount": 1803
            },
            {
                "name": "2 Star",
                "starCount": 6965,
                "reviewCount": 1855
            },
            {
                "name": "3 Star",
                "starCount": 1572,
                "reviewCount": 2804
            },
            {
                "name": "4 Star",
                "starCount": 837,
                "reviewCount": 4091
            },
            {
                "name": "5 Star",
                "starCount": 706,
                "reviewCount": 5088
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 2994,
                "postedAt": "2023-04-21T05:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 7062,
                "postedAt": "2023-04-20T04:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 7259,
                "postedAt": "2023-04-19T03:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 1443,
                "postedAt": "2023-04-18T02:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 8008,
                "postedAt": "2023-04-17T01:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 4153,
                "postedAt": "2023-04-16T00:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 6053,
                "postedAt": "2023-04-14T23:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 2459,
                "postedAt": "2023-04-13T22:58:02.233Z"
            }
        ],
        "status": "sale",
        "inventoryType": "out_of_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 32,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 810,
        "createdAt": "2023-03-30T08:58:02.233Z",
        "category": "Accessories",
        "gender": "Women",
        "colors": [
            "#1890FF"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b23",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_23.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Chuck Taylor All Star Lift Sneaker",
        "code": "38BEE2722",
        "sku": "WW75K52122YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 69.22,
        "priceSale": null,
        "totalRating": 3.9,
        "totalReview": 2383,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 567,
                "reviewCount": 8613
            },
            {
                "name": "2 Star",
                "starCount": 2927,
                "reviewCount": 5252
            },
            {
                "name": "3 Star",
                "starCount": 4788,
                "reviewCount": 6242
            },
            {
                "name": "4 Star",
                "starCount": 1279,
                "reviewCount": 1038
            },
            {
                "name": "5 Star",
                "starCount": 1931,
                "reviewCount": 2591
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 5162,
                "postedAt": "2023-04-21T05:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 3966,
                "postedAt": "2023-04-20T04:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 1898,
                "postedAt": "2023-04-19T03:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 5775,
                "postedAt": "2023-04-18T02:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 326,
                "postedAt": "2023-04-17T01:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 4377,
                "postedAt": "2023-04-16T00:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 7709,
                "postedAt": "2023-04-14T23:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 5252,
                "postedAt": "2023-04-13T22:58:02.233Z"
            }
        ],
        "status": "new",
        "inventoryType": "low_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 218,
        "createdAt": "2023-03-29T07:58:02.233Z",
        "category": "Accessories",
        "gender": "Men",
        "colors": [
            "#1890FF",
            "#94D82D",
            "#FFC107"
        ]
    },
    {
        "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b24",
        "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_24.jpg",
        "images": [
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
            "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
        ],
        "name": "Run Star Hike Platform Sneaker",
        "code": "38BEE2723",
        "sku": "WW75K52123YW/SV",
        "tags": [
            "Dangal",
            "The Sting",
            "2001: A Space Odyssey",
            "Singin' in the Rain"
        ],
        "price": 60.96,
        "priceSale": null,
        "totalRating": 1.8,
        "totalReview": 1674,
        "ratings": [
            {
                "name": "1 Star",
                "starCount": 1996,
                "reviewCount": 4498
            },
            {
                "name": "2 Star",
                "starCount": 5419,
                "reviewCount": 6743
            },
            {
                "name": "3 Star",
                "starCount": 3518,
                "reviewCount": 3483
            },
            {
                "name": "4 Star",
                "starCount": 1262,
                "reviewCount": 3244
            },
            {
                "name": "5 Star",
                "starCount": 4140,
                "reviewCount": 7819
            }
        ],
        "reviews": [
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
                "name": "Jayvion Simon",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
                "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
                "rating": 2.5,
                "isPurchased": true,
                "helpful": 261,
                "postedAt": "2023-04-21T05:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
                "name": "Lucian Obrien",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
                "comment": "Quis veniam aut saepe aliquid nulla.",
                "rating": 2,
                "isPurchased": true,
                "helpful": 6083,
                "postedAt": "2023-04-20T04:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
                "name": "Deja Brady",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
                "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
                "rating": 4.9,
                "isPurchased": true,
                "helpful": 7834,
                "postedAt": "2023-04-19T03:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
                "name": "Harrison Stein",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
                "comment": "Error ut sit vel molestias velit.",
                "rating": 2,
                "isPurchased": false,
                "helpful": 2161,
                "postedAt": "2023-04-18T02:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
                "name": "Reece Chung",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
                "comment": "Quo quia sit nihil nemo doloremque et.",
                "rating": 4,
                "isPurchased": false,
                "helpful": 410,
                "postedAt": "2023-04-17T01:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
                "name": "Lainey Davidson",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
                "comment": "Autem doloribus harum vero laborum.",
                "rating": 5,
                "isPurchased": true,
                "helpful": 8386,
                "postedAt": "2023-04-16T00:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
                "name": "Cristopher Cardenas",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
                "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
                "rating": 4.9,
                "isPurchased": false,
                "helpful": 9028,
                "postedAt": "2023-04-14T23:58:02.233Z"
            },
            {
                "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
                "name": "Melanie Noble",
                "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
                "comment": "Voluptas sunt magni adipisci praesentium saepe.",
                "rating": 5,
                "isPurchased": false,
                "helpful": 3816,
                "postedAt": "2023-04-13T22:58:02.233Z"
            }
        ],
        "status": "",
        "inventoryType": "out_of_stock",
        "sizes": [
            "6",
            "7",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
            "10.5",
            "11",
            "11.5",
            "12",
            "13"
        ],
        "available": 2,
        "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
        "sold": 374,
        "createdAt": "2023-03-28T06:58:02.233Z",
        "category": "Apparel",
        "gender": "Women",
        "colors": [
            "#FF4842",
            "#1890FF"
        ]
    }
]

export const productDetail = {
    "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
    "cover": "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
    "images": [
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_1.jpg",
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_2.jpg",
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_3.jpg",
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_4.jpg",
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_5.jpg",
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_6.jpg",
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_7.jpg",
        "https://api-prod-minimal-v4.vercel.app/assets/images/products/product_8.jpg"
    ],
    "name": "Nike Air Force 1 NDESTRUKT",
    "code": "38BEE270",
    "sku": "WW75K5210YW/SV",
    "tags": [
        "Dangal",
        "The Sting",
        "2001: A Space Odyssey",
        "Singin' in the Rain"
    ],
    "price": 16.19,
    "priceSale": 16.19,
    "totalRating": 2.5,
    "totalReview": 5135,
    "ratings": [
        {
            "name": "1 Star",
            "starCount": 98,
            "reviewCount": 8613
        },
        {
            "name": "2 Star",
            "starCount": 9473,
            "reviewCount": 4887
        },
        {
            "name": "3 Star",
            "starCount": 1794,
            "reviewCount": 5455
        },
        {
            "name": "4 Star",
            "starCount": 9575,
            "reviewCount": 7331
        },
        {
            "name": "5 Star",
            "starCount": 6801,
            "reviewCount": 7714
        }
    ],
    "reviews": [
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
            "name": "Jayvion Simon",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg",
            "comment": "Assumenda nam repudiandae rerum fugiat vel maxime.",
            "rating": 2.5,
            "isPurchased": true,
            "helpful": 258,
            "postedAt": "2023-04-21T14:22:13.898Z"
        },
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
            "name": "Lucian Obrien",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg",
            "comment": "Quis veniam aut saepe aliquid nulla.",
            "rating": 2,
            "isPurchased": true,
            "helpful": 9776,
            "postedAt": "2023-04-20T13:22:13.898Z"
        },
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
            "name": "Deja Brady",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg",
            "comment": "Reprehenderit ut voluptas sapiente ratione nostrum est.",
            "rating": 4.9,
            "isPurchased": true,
            "helpful": 1678,
            "postedAt": "2023-04-19T12:22:13.898Z"
        },
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
            "name": "Harrison Stein",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg",
            "comment": "Error ut sit vel molestias velit.",
            "rating": 2,
            "isPurchased": false,
            "helpful": 6546,
            "postedAt": "2023-04-18T11:22:13.898Z"
        },
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
            "name": "Reece Chung",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg",
            "comment": "Quo quia sit nihil nemo doloremque et.",
            "rating": 4,
            "isPurchased": false,
            "helpful": 7337,
            "postedAt": "2023-04-17T10:22:13.898Z"
        },
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
            "name": "Lainey Davidson",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg",
            "comment": "Autem doloribus harum vero laborum.",
            "rating": 5,
            "isPurchased": true,
            "helpful": 8466,
            "postedAt": "2023-04-16T09:22:13.898Z"
        },
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
            "name": "Cristopher Cardenas",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg",
            "comment": "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
            "rating": 4.9,
            "isPurchased": false,
            "helpful": 1506,
            "postedAt": "2023-04-15T08:22:13.898Z"
        },
        {
            "id": "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
            "name": "Melanie Noble",
            "avatarUrl": "https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg",
            "comment": "Voluptas sunt magni adipisci praesentium saepe.",
            "rating": 5,
            "isPurchased": false,
            "helpful": 9493,
            "postedAt": "2023-04-14T07:22:13.898Z"
        }
    ],
    "status": "sale",
    "inventoryType": "in_stock",
    "sizes": [
        "6",
        "7",
        "8",
        "8.5",
        "9",
        "9.5",
        "10",
        "10.5",
        "11",
        "11.5",
        "12",
        "13"
    ],
    "available": 98,
    "description": "\n<p><strong><small> SPECIFICATION</small></strong></p>\n<p>Leather panels. Laces. Rounded toe. Rubber sole.\n<br /><br />\n<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>\n<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>\n",
    "sold": 476,
    "createdAt": "2023-04-21T14:22:13.899Z",
    "category": "Apparel",
    "gender": "Men",
    "colors": [
        "#00AB55",
        "#000000"
    ]
}

export const GENDER = [
    {
        id: '1',
        name: 'male',
        label: 'Male'
    },
    {
        id: '2',
        name: 'female',
        label: 'Female',
    },
    {
        id: '3',
        name: 'others',
        label: 'Others'
    }
]
/**
 * LIST 
 */
export const USER_LIST_PAGE = [
    {
        id: 'firstname',
        label: 'First Name',
        align: 'left',
    },
    {
        id: 'lastname',
        label: 'Last Name',
        align: 'left',
    },
    {
        id: 'email',
        label: 'Email',
        align: 'left',
    },
    {
        id: 'isApproved',
        label: 'Approved',
        align: 'left',
    },
    {
        id: 'country',
        label: 'Country',
        align: 'left',
    },
    {
        id: 'state',
        label: 'State',
        align: 'left',
    },
    {
        id: 'city',
        label: 'City',
        align: 'left',
    },
]

export const ORGANIZATION_LIST_PAGE = [
    {
        id: 'orgName',
        label: 'Name',
        align: 'left',
    },
    {
        id: 'orgCode',
        label: 'Org Code',
        align: 'left',
    },
    {
        id: 'isApproved',
        label: 'Approved',
        align: 'left',
    },
    // {
    //     id: 'panNumber',
    //     label: 'Pan Number',
    //     align: 'left',
    // },
    // {
    //     id: 'gstIn',
    //     label: 'GST IN',
    //     align: 'left',
    // },
]

export const BOOK_LIST_PAGE = [
    {
        id: 'name',
        label: 'Name',
        align: 'left',
    },
    {
        id: 'price',
        label: 'Price',
        align: 'left',
    },
    {
        id: 'status',
        label: 'Status',
        align: 'left',
    },
    {
        id: 'createdAt',
        label: 'Created At',
        align: 'left',
    },

]


export const BIN_LIST_PAGE = [
    {
        id: 'name',
        label: 'Name',
        align: 'left',
    },
    {
        id: 'deletedAt',
        label: 'Date Deleted',
        align: 'left',
    },
    {
        id: 'deletedBy',
        label: 'Deleted By',
        align: 'left',
    },
    {
        id: 'createdBy',
        label: 'Created By',
        align: 'left',
    },
    {
        id: 'path',
        label: 'Original Location',
        align: 'left',
        minWidth: 100
    },

]

export const ORG_SUBSCRIPTION_LIST_PAGE = [
    {
        id: 'planName',
        label: 'Plan Name',
        align: 'left',
    },
    {
        id: 'totalPrice',
        label: 'Price',
        align: 'left',
    },
    {
        id: 'createdAt',
        label: 'Subscribed On',
        align: 'left',
    },
]

export const MY_SUBSCRIPTION_LIST_PAGE = [
    {
        id: 'planName',
        label: 'Plan Name',
        align: 'left',
    },
    {
        id: 'createdAt',
        label: 'Subscribed On',
        align: 'left',
    },
]
/**
 * NEW FORM
 */

export const BOOK_NEW_FORM_PAGE = [
    {
        id: '1',
        name: 'name',
        label: 'Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false,
    },
    {
        id: '2',
        name: 'description',
        label: 'Description',
        type: FIELD_TYPES.LONGTEXT,
        required: true,
        readOnly: false,
    },
    {
        id: '3',
        name: 'price',
        label: 'Price',
        type: FIELD_TYPES.NUMBER,
        required: true,
        readOnly: false,
    },
    {
        id: '4',
        name: 'image',
        label: 'Images',
        type: FIELD_TYPES.IMAGE,
        required: true,
        readOnly: false,
    },

]

export const USER_NEW_FORM_PAGE = [
    {
        id: '1',
        name: 'firstname',
        label: 'First Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    {
        id: '2',
        name: 'lastname',
        label: 'Last Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    {
        id: '3',
        name: 'email',
        label: 'Email',
        type: FIELD_TYPES.EMAIL,
        required: true,
        readOnly: false
    },
    // {
    //     id: '4',
    //     name: 'phonenumber',
    //     label: 'Phone Number',
    //     type: FIELD_TYPES.PHONE,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '5',
    //     name: 'country',
    //     label: 'Country',
    //     type: FIELD_TYPES.COUNTRY_PICKLIST,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '6',
    //     name: 'state',
    //     label: 'State/Region',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '7',
    //     name: 'city',
    //     label: 'City',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '8',
    //     name: 'address',
    //     label: 'Address',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '9',
    //     name: 'zip',
    //     label: 'Zip/Code',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    {
        id: '11',
        name: 'roleId',
        label: 'Role',
        type: FIELD_TYPES.ROLE_PICKLIST,
        required: true,
        readOnly: false
    },

]

export const ORGANIZATION_NEW_FORM_PAGE = [
    {
        id: '1',
        name: 'orgName',
        label: 'Organization Name',
        type: FIELD_TYPES.TEXT,
        performAction: true,
        showErrors: true,
        required: true,
        readOnly: false
    },
    {
        id: '2',
        name: 'orgCode',
        label: 'Org Code',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    // {
    //     id: '3',
    //     name: 'gstIn',
    //     label: 'GST IN',
    //     type: FIELD_TYPES.NUMBER,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '4',
    //     name: 'panNumber',
    //     label: 'Pan Number',
    //     type: FIELD_TYPES.NUMBER,
    //     required: true,
    //     readOnly: false
    // },
]

export const PLAN_NEW_FORM_PAGE = [
    {
        id: '1',
        name: 'planName',
        label: 'Plan Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    }
]
/**
 * EDIT FORM
 */

export const USER_EDIT_FORM_PAGE = [
    {
        id: '1',
        name: 'firstname',
        label: 'First Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    {
        id: '2',
        name: 'lastname',
        label: 'Last Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    {
        id: '3',
        name: 'email',
        label: 'Email',
        type: FIELD_TYPES.EMAIL,
        required: true,
        readOnly: true
    },
    // {
    //     id: '4',
    //     name: 'phonenumber',
    //     label: 'Phone Number',
    //     type: FIELD_TYPES.PHONE,
    //     required: true,
    //     readOnly: true
    // },
    // Removing this information for now 
    // {
    //     id: '5',
    //     name: 'country',
    //     label: 'Country',
    //     type: FIELD_TYPES.COUNTRY_PICKLIST,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '6',
    //     name: 'state',
    //     label: 'State/Region',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '7',
    //     name: 'city',
    //     label: 'City',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '8',
    //     name: 'address',
    //     label: 'Address',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '9',
    //     name: 'zip',
    //     label: 'Zip/Code',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    {
        id: '11',
        name: 'roleName',
        label: 'Role',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },

]

export const ORGANIZATION_EDIT_FORM_PAGE = [
    {
        id: '1',
        name: 'orgName',
        label: 'Organization Name',
        type: FIELD_TYPES.TEXT,
        performAction: true,
        showErrors: true,
        required: true,
        readOnly: false
    },
    {
        id: '2',
        name: 'orgCode',
        label: 'Org Code',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    // {
    //     id: '3',
    //     name: 'gstIn',
    //     label: 'GST IN',
    //     type: FIELD_TYPES.NUMBER,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '4',
    //     name: 'panNumber',
    //     label: 'Pan Number',
    //     type: FIELD_TYPES.NUMBER,
    //     required: true,
    //     readOnly: false
    // },
]


export const PLAN_EDIT_FORM_PAGE = [
    {
        id: '1',
        name: 'planName',
        label: 'Plan Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    }
]
/**
 * EDIT FORM
 */

export const USER_DETAIL_FORM_PAGE = [
    {
        id: '1',
        name: 'firstname',
        label: 'First Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    {
        id: '2',
        name: 'lastname',
        label: 'Last Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    {
        id: '3',
        name: 'email',
        label: 'Email',
        type: FIELD_TYPES.EMAIL,
        required: true,
        readOnly: true
    },
    // {
    //     id: '4',
    //     name: 'phonenumber',
    //     label: 'Phone Number',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '5',
    //     name: 'country',
    //     label: 'Country',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '6',
    //     name: 'state',
    //     label: 'State/Region',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '7',
    //     name: 'city',
    //     label: 'City',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '8',
    //     name: 'address',
    //     label: 'Address',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '9',
    //     name: 'zip',
    //     label: 'Zip/Code',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '10',
    //     name: 'company',
    //     label: 'Company',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    {
        id: '11',
        name: 'roleName',
        label: 'Role',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
]

export const ORGANIZATION_DETAIL_FORM_PAGE = [
    {
        id: '1',
        name: 'orgName',
        label: 'Organization Name',
        type: FIELD_TYPES.TEXT,
        required: false,
        readOnly: true
    },
    {
        id: '2',
        name: 'orgCode',
        label: 'Org Code',
        type: FIELD_TYPES.TEXT,
        required: false,
        readOnly: true
    },
    // {
    //     id: '3',
    //     name: 'gstIn',
    //     label: 'GST IN',
    //     type: FIELD_TYPES.NUMBER,
    //     required: false,
    //     readOnly: true
    // },
    // {
    //     id: '4',
    //     name: 'panNumber',
    //     label: 'Pan Number',
    //     type: FIELD_TYPES.NUMBER,
    //     required: false,
    //     readOnly: true
    // },

]


/**
 * END EDIT FORM
 */

export const CHANGE_PASSWORD_FORM_PAGE = [
    {
        id: '1',
        name: 'oldPassword',
        label: 'Old Password',
        type: FIELD_TYPES.PASSWORD,
    },
    {
        id: '2',
        name: 'newPassword',
        label: 'New Password',
        type: FIELD_TYPES.PASSWORD,
    },
    {
        id: '3',
        name: 'confirmNewPassword',
        label: 'Confirm New Password',
        type: FIELD_TYPES.PASSWORD,
    },
]

export const ACCOUNT_GENERAL_FORM = [
    {
        id: '1',
        name: 'firstname',
        label: 'First Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    {
        id: '2',
        name: 'lastname',
        label: 'Last Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    {
        id: '3',
        name: 'email',
        label: 'Email',
        type: FIELD_TYPES.EMAIL,
        required: true,
        readOnly: true
    },
    // {
    //     id: '4',
    //     name: 'phonenumber',
    //     label: 'Phone Number',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '10',
    //     name: 'gender',
    //     label: 'Gender',
    //     type: FIELD_TYPES.GENDER_PICKLIST,
    //     required: true,
    //     readOnly: false
    // },

    // {
    //     id: '5',
    //     name: 'country',
    //     label: 'Country',
    //     type: FIELD_TYPES.COUNTRY_PICKLIST,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '6',
    //     name: 'state',
    //     label: 'State/Region',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '7',
    //     name: 'city',
    //     label: 'City',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '8',
    //     name: 'address',
    //     label: 'Address',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '9',
    //     name: 'zip',
    //     label: 'Zip/Code',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
]

export const ACCOUNT_GENERAL_DETAIL = [
    {
        id: '1',
        name: 'firstname',
        label: 'First Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    {
        id: '2',
        name: 'lastname',
        label: 'Last Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    {
        id: '3',
        name: 'email',
        label: 'Email',
        type: FIELD_TYPES.EMAIL,
        required: true,
        verification: true,
        readOnly: true
    },
    // {
    //     id: '4',
    //     name: 'phonenumber',
    //     label: 'Phone Number',
    //     type: FIELD_TYPES.PHONE,
    //     required: true,
    //     verification: true,
    //     readOnly: true
    // },
    // {
    //     id: '10',
    //     name: 'gender',
    //     label: 'Gender',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },

    // {
    //     id: '5',
    //     name: 'country',
    //     label: 'Country',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '6',
    //     name: 'state',
    //     label: 'State/Region',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '7',
    //     name: 'city',
    //     label: 'City',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '8',
    //     name: 'address',
    //     label: 'Address',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '9',
    //     name: 'zip',
    //     label: 'Zip/Code',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
]

export const INDIVIDUAL_USER_SIGN_UP_FORM = [
    {
        id: '1',
        name: 'firstname',
        label: 'First Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false,
        width: '100%'
    },
    {
        id: '2',
        name: 'lastname',
        label: 'Last Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false,
        width: '100%'
    },
    // {
    //     id: '3',
    //     name: 'panNumber',
    //     label: 'Pan Number',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false,
    //     width: '100%'
    // },
    {
        id: '4',
        name: 'email',
        label: 'Email',
        type: FIELD_TYPES.EMAIL,
        required: true,
        readOnly: false,
        width: '100%'
    },
    {
        id: '5',
        name: 'password',
        label: 'Password',
        type: FIELD_TYPES.PASSWORD,
        required: true,
        disableIcon: false,
        readOnly: false,
        width: '100%'
    },
    // {
    //     id: '6',
    //     name: 'phonenumber',
    //     label: 'Phone Number',
    //     type: FIELD_TYPES.PHONE,
    //     required: true,
    //     readOnly: false,
    //     width: '100%'
    // },
]

export const ORGANIZATION_SIGN_UP_FORM = [
    {
        id: '1',
        name: 'orgName',
        label: 'Organization Name',
        type: FIELD_TYPES.TEXT,
        performAction: true,
        required: true,
        readOnly: false,
        width: '100%'
    },
    // {
    //     id: '2',
    //     name: 'orgCode',
    //     label: 'Organization Code',
    //     type: FIELD_TYPES.TEXT,
    //     performAction: true,
    //     showErrors: true,
    //     required: true,
    //     readOnly: true,
    //     width: '100%'
    // },
    {
        id: '3',
        name: 'company_address',
        label: 'Company Address',
        type: FIELD_TYPES.TEXT,
        performAction: true,
        showErrors: true,
        required: true,
        readOnly: false,
        width: '100%'
    },
    {
        id: '4',
        name: 'billing_address',
        label: 'Billing Address',
        type: FIELD_TYPES.TEXT,
        performAction: true,
        showErrors: true,
        required: true,
        readOnly: false,
        width: '100%'
    },
    // {
    //     id: '2',
    //     name: 'gstIn',
    //     label: 'GST IN',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false,
    // width:'47%'
    // },
    // {
    //     id: '3',
    //     name: 'panNumber',
    //     label: 'Pan Number',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false,
    // width:'47%'
    // },
    {
        id: '5',
        name: 'firstname',
        label: 'Admin First Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false,
        width: '47%'
    },
    {
        id: '6',
        name: 'lastname',
        label: 'Admin Last Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false,
        width: '47%'
    },
    {
        id: '7',
        name: 'email',
        label: 'Admin Email',
        type: FIELD_TYPES.EMAIL,
        required: true,
        readOnly: false,
        width: '100%'
    },
    {
        id: '8',
        name: 'password',
        label: 'Password',
        type: FIELD_TYPES.PASSWORD,
        required: true,
        disableIcon: false,
        readOnly: false,
        width: '100%'
    },
    // {
    //     id: '9',
    //     name: 'phonenumber',
    //     label: 'Phone Number (Optional)',
    //     type: FIELD_TYPES.PHONE,
    //     required: false,
    //     readOnly: false,
    //     width: '100%'
    // },

]

export const ORGANIZATION_GENERAL_DETAIL = [
    {
        id: '1',
        name: 'orgName',
        label: 'Organization Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    {
        id: '4',
        name: 'orgCode',
        label: 'Organization Code',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    // {
    //     id: '2',
    //     name: 'gstIn',
    //     label: 'GST IN',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: true
    // },
    // {
    //     id: '3',
    //     name: 'panNumber',
    //     label: 'Pan Number',
    //     type: FIELD_TYPES.EMAIL,
    //     required: true,
    //     readOnly: true
    // },
    {
        id: '3',
        name: 'companyAddress',
        label: 'Company Address',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
    {
        id: '4',
        name: 'billingAddress',
        label: 'Billing Address',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: true
    },
]

export const ORGANIZATION_GENERAL_FORM = [
    {
        id: '1',
        name: 'orgName',
        label: 'Organization Name',
        type: FIELD_TYPES.TEXT,
        required: false,
        readOnly: true
    },
    {
        id: '4',
        name: 'orgCode',
        label: 'Organization Code',
        type: FIELD_TYPES.TEXT,
        required: false,
        readOnly: true
    },
    // {
    //     id: '2',
    //     name: 'gstIn',
    //     label: 'GST IN',
    //     type: FIELD_TYPES.TEXT,
    //     required: true,
    //     readOnly: false
    // },
    // {
    //     id: '3',
    //     name: 'panNumber',
    //     label: 'Pan Number',
    //     type: FIELD_TYPES.NUMBER,
    //     required: true,
    //     readOnly: false
    // },
     {
        id: '3',
        name: 'companyAddress',
        label: 'Company Address',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
    {
        id: '4',
        name: 'billingAddress',
        label: 'Billing Address',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },
]

export const FILE_UPLOAD_FORM = [
    {
        id: '1',
        name: 'image',
        label: 'File',
        type: FIELD_TYPES.IMAGE,
        required: true,
        readonly: false
    }
]

export const FOLDER_UPLOAD_FORM = [
    {
        id: '1',
        name: 'folder',
        label: 'Folder',
        type: FIELD_TYPES.FOLDER,
        required: true,
        readonly: false
    }
]

export const DATA_TRAINING_TASK_FORM_PAGE = [
    {
        id: '1',
        name: 'taskName',
        label: 'Task Name',
        type: FIELD_TYPES.TEXT,
        required: true,
        readOnly: false
    },

]
